export default function trackEvent(...args) {
  if (window.ga && typeof window.ga === 'function') {
    window.ga('send', 'event', ...args);
  } else {
    console.log('[TrackEvent] GA is not loaded, but here\'s the event data:', ...args);
  }
}
